import React from 'react'

export const MoreIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 10.834a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667zM10 5a.833.833 0 1 0 0-1.667A.833.833 0 0 0 10 5zM10 16.667A.833.833 0 1 0 10 15a.833.833 0 0 0 0 1.667z" stroke="#98A2B3" strokeWidth="1.667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}
